import { stripUnit } from "../../styles/utils/utils";
export const listItemSpacing = (spaceSize, multiplier, gutter) => {
    const spacing = stripUnit(spaceSize) * multiplier;
    return {
        spacing: `${spacing}px`,
        gutteredSpacing: `${spacing - stripUnit(gutter)}px`,
    };
};
